import React from "react";
import "./dropdownwithbutton.css";
export default function DropdownWithButton({ options, placeholder, OnClick }) {
  return (
    <div className="dropdown-main-container">
      <div class="dropdown-wrapper">
        <select class="dropdown-select" id="dropdown-select" name="options">
          <option value="" disabled selected>
            Select
          </option>
          {options &&
            options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
        </select>
      </div>
      .
      <div className="dropdown-add-button-container">
        <button className="dropdown-add-button" OnClick={OnClick}>
          Apply
        </button>
      </div>
    </div>
  );
}
